import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import Layout from './common/Layout';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import Loader from './common/Loader';

// CSS imports
import './assets/css/all.min.css';
import './assets/css/animate.min.css';
import './assets/css/bootstrap-icons.css';
import './assets/css/bootstrap.min.css';
import './assets/css/boxicons.min.css';
import './assets/css/fontawesome.min.css';
import './assets/css/jquery.fancybox.min.css';
import './assets/css/magnific-popup.css';
import './assets/css/nice-select.css';
import './assets/css/preloader.css';
import './assets/css/style2.css';
import './assets/css/style2.css.map';
// import "./assets/css/style2.scss";
import './assets/css/swiper-bundle.min.css';
import './assets/css/index.css';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import ServiceDetails from './components/services/ServiceDetails';
import Projects from './pages/Projects';
import ProjectDetails from './components/projects/ProjectDetails';
import Contacts from './pages/Contacts';
import Teams from './pages/Teams';
import Error from './pages/Error';
import Blogs from './pages/Blogs';
import BlogDetails from './components/blogs/BlogDetails';
import ScrollToTop from './common/ScrollToTop';
import Industry from './pages/Industry';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsAndCondition';
import IndustryDetails from './components/industries/IndustryDetails';
import { ToastContainer } from 'react-toastify';

const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [tab, setTab] = useState('home');
  const [subMenuTag, setSubMenuTag] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 300);
  }, [tab]);

  return (
    <Router>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
      <Layout>
        {showLoader && <Loader />}
        <ScrollToTop />
        <Navbar
          tab={tab}
          setTab={setTab}
          subMenuTag={subMenuTag}
          setSubMenuTag={setSubMenuTag}
        />
        <Routes>
          <Route path='/' element={<Home setTab={setTab} />} />
          <Route path='/services' element={<Services setTab={setTab} />} />
          <Route
            path='/services/:serviceId'
            element={<ServiceDetails setTab={setTab} />}
          />
          {/* <Route path="/about" element={<About setTab={setTab} />} />
          <Route path="/projects" element={<Projects setTab={setTab} />} />
          <Route
            path="/projects/:projectId"
            element={<ProjectDetails setTab={setTab} />}
          /> */}
          <Route path='/teams' element={<Teams />} />
          <Route path='/blogs' element={<Blogs setTab={setTab} />} />
          <Route path='/blogs/:blogId' element={<BlogDetails />} />
          <Route path='/industries' element={<Industry />} />
          <Route path='/industries/:industryId' element={<IndustryDetails />} />
          <Route path='/contact-us' element={<Contacts setTab={setTab} />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsConditions />} />
          <Route path='*' element={<Error />} />
        </Routes>
        <Footer />
      </Layout>
    </Router>
  );
};

export default App;
